<template>
  <div class="home">
    <h1><small>Welcome on </small><br>TCY archive</h1>
    <br>
    <br>
    <ArtworksList :artworks='posts' />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ArtworksList from '@/components/ArtworksList.vue'

export default {
  name: 'Home',
  mounted () {
    this.$store.dispatch('getPosts')
  },
  computed: mapGetters([
    'posts'
  ]),
  components : {
    ArtworksList
  }
}
</script>

<style>
  .home {
    text-align:center
  }
</style>
